package org.example.project.screens_sys

import kotlinx.browser.window
import kotlinx.coroutines.await
import kotlinx.serialization.builtins.ListSerializer
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json
import org.example.project.manager.LumaticaApiManager
import org.example.project.enginetabular.loadWithTabularFilters
import org.example.project.manager.LumaticaApiSettings
import org.example.project.service.GlobalManager
import org.example.project.utils.All
import org.w3c.fetch.Headers
import org.w3c.fetch.RequestInit

object FirmenregisterApi {
    private val json = Json {
        ignoreUnknownKeys = true
        encodeDefaults = false
    }

    suspend fun loadCompanies(): List<All> =
        decodeList(LumaticaApiManager.call("firmenregister/companies"))
            .withoutInternalSystemCompanies()

    suspend fun searchCompanies(filters: Map<String, String>): List<All> =
        decodeList(loadWithTabularFilters("firmenregister/companies", filters))
            .withoutInternalSystemCompanies()

    suspend fun saveCompany(firma: All): All? =
        decodeOne(postCompanyJson("firmenregister/save-company-json", firma))
            ?.also(::markCompanyChanged)

    suspend fun loadCompanyUsers(firmenId: String): List<All> {
        if (firmenId.isBlank()) return emptyList()
        return decodeList(LumaticaApiManager.call("userverwaltung/company-users/${apiPart(firmenId)}"))
    }

    private fun decodeOne(raw: String): All? =
        runCatching { json.decodeFromString(All.AllNames.serializer(), raw) }.getOrNull()

    private fun decodeList(raw: String): List<All> =
        runCatching { json.decodeFromString(ListSerializer(All.AllNames.serializer()), raw) }.getOrDefault(emptyList())

    private fun markCompanyChanged(firma: All) {
        val firmenId = firma.firmenId.ifBlank { firma.id }
        if (firmenId.isNotBlank()) {
            GlobalManager.markJsonChanged("firma.json", "register/$firmenId/firma.json")
        }
    }

    private suspend fun postCompanyJson(endpoint: String, firma: All): String {
        val response = window.fetch(
            "${LumaticaApiSettings.getBaseUrl()}/api/$endpoint",
            RequestInit(
                method = "POST",
                headers = LumaticaApiManager.auditHeaders("application/json"),
                body = json.encodeToString(All.AllNames.serializer(), firma)
            )
        ).await()
        return response.text().await()
    }

    private fun apiPart(value: String): String =
        js("encodeURIComponent")(if (value.isBlank()) "~" else value) as String
}
